import React, { PureComponent } from 'react'
import { findDOMNode } from 'react-dom'
import outy from 'outy'
import { Manager, Target, Popper, Arrow } from '../components/popover'

class Popover extends PureComponent {
  state = {
    isOpen: false,
  }
  componentDidMount() {
    this._setOutsideTap()
  }

  componentDidUpdate(lastProps, lastState) {
    if (lastState.isOpen !== this.state.isOpen) {
      setTimeout(() => this._setOutsideTap())
    }
  }

  componentWillUnmount() {
    this.outsideTap.remove()
  }

  _setOutsideTap = () => {
    const elements = [this.target]

    if (this.popper) {
      elements.push(this.popper)
    }

    if (this.outsideTap) {
      this.outsideTap.remove()
    }

    this.outsideTap = outy(
      elements,
      ['click', 'touchstart'],
      this._handleOutsideTap,
    )
  }

  _handleOutsideTap = () => {
    this.setState({ isOpen: false })
  }

  handleClick = () => {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen,
    }))
  }

  render() {
      let {content}=this.props;
    return (
      <div>
        <Manager>
          <Target
            innerRef={c => (this.target = findDOMNode(c))}
            className="valuetext"
            onClick={this.handleClick}
          >
            商品明细
          </Target>
          {this.state.isOpen && (
            <Popper 
                className="popper"
                // component={CustomPopper}
                innerRef={c => {
                    this.popper = findDOMNode(c)
              }}>
              {content}
              {/* <Arrow className="popper__arrow" /> */}
            </Popper>
          )}
        </Manager>
      </div>
    )
  }
}

export default Popover
